const PERMISSION_KEY= "core:user_referral_reward";
const PAGE_URL = {
    USER_REFERRAL_REWARD_PAGE: "/admin/core/user-referral-reward"
}

export {PERMISSION_KEY, PAGE_URL}

